import {
  Box,
  Grid,
  Tooltip,
  Typography,
  FormHelperText,
} from "@material-ui/core";
import {
  Error as ErrorIcon,
  InfoOutlined as InfoOutlinedIcon,
} from "@material-ui/icons";
import React from "react";

export const Form: React.FC = (props) => {
  return (
    <Grid container spacing={2}>
      {props.children}
    </Grid>
  );
};

export const Error: React.FC<{
  error?: Error | null;
}> = (props) => {
  return props.error && props.error.message ? (
    <FormHelperText
      error={!!props.error}
      component={Box}
      display="flex"
      alignItems="center"
      pl={1}
    >
      <ErrorIcon color="inherit" fontSize="small" />
      <Typography variant="caption" component={Box} pl={0.5}>
        {props.error.message}
      </Typography>
    </FormHelperText>
  ) : null;
};

export const LineBreak: React.FC = () => <Box flexBasis="100%" />;

export const Title: React.FC<{
  children: string;
  error?: Error;
  subtitle?: string;
  tooltip?: string;
  info?: string;
}> = (props) => {
  return (
    <Grid item xs={12}>
      <Box
        display="flex"
        alignItems="center"
        border={1}
        borderTop={0}
        borderRight={0}
        borderLeft={0}
        borderColor="grey.500"
        color={props.error ? "error.main" : "text.primary"}
      >
        <Typography
          variant="subtitle2"
          component={Box}
          noWrap
          py={1}
          pr={props.tooltip ? 0.5 : 0}
        >
          {props.children}
        </Typography>
        {props.tooltip ? (
          <Tooltip arrow title={props.tooltip}>
            <InfoOutlinedIcon color="primary" fontSize="small" />
          </Tooltip>
        ) : null}
        {props.info ? (
          <Box display="flex" alignItems="center" pl={1}>
            <InfoOutlinedIcon color="primary" fontSize="small" />
            <Box pl={0.5}>
              <Typography color="primary" variant="caption">
                {props.info}
              </Typography>
            </Box>
          </Box>
        ) : null}
        <Error error={props.error} />
      </Box>
      {props.subtitle ? (
        <Box display="flex" alignItems="center" pt={2}>
          <Typography variant="caption" component="p" color="primary">
            {props.subtitle}
          </Typography>
        </Box>
      ) : null}
    </Grid>
  );
};

export const Text: React.FC<{
  children: any;
  color?: string;
}> = (props) => {
  return (
    <Grid item xs={12}>
      <Box display="flex" alignItems="center" color={props.color}>
        <Typography variant="caption" component="div">
          {props.children}
        </Typography>
      </Box>
    </Grid>
  );
};

export const TextError: React.FC<{
  children: string;
}> = (props) => {
  return (
    <Grid item xs={12}>
      <Box display="flex" alignItems="center" color="red">
        <Typography variant="caption" component="p">
          {props.children}
        </Typography>
      </Box>
    </Grid>
  );
};
